import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const USERFEEDBACKLINKBLOCK_LEGACY_FIELD_ORDER = [
  "text",
  "url",
  "target",
  "icon",
  { type: 'separator' },
  { type: 'heading', value: "Afficher uniquement si la commande est sur ce shop" },
  "only_on_shop"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  userFeedbackLinkBlockDescriptor: _generatedUserFeedbackLinkBlockDescriptor,
  userFeedbackLinkBlockBlocDefinition,
  userFeedbackLinkBlockDashboardLayout,
  userFeedbackLinkBlockConfig,
  userFeedbackLinkBlockResolveConfig,
  userFeedbackLinkBlockProperties,
} = doodBlockConfig(
  {
    name: "User feedback link",
    componentType: 'UserFeedbackLinkBlockComponent',
    category: 'content',
    description: "User feedback link.",
    keywords: [],
    allowedIn: [
      { bloc: "UserFeedbackBlockComponent", slot: "modal_positive_rating_content" },
      { bloc: "UserFeedbackBlockComponent", slot: "modal_negative_rating_content" },
    ],
    sharedFields: {}
  },

  () => ({
    text: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.user-feedback-link.text.label",
        placeholder: "pages.blocks.user-feedback-link.text.placeholder",
      }
    }),
    url: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.user-feedback-link.url.label",
        placeholder: "pages.blocks.user-feedback-link.url.placeholder",
        help: "pages.blocks.user-feedback-link.url.help",
      }
    }),
    target: propertyValue({
      type: 'select',
      value: "_blank",
      options: {
        label: "pages.blocks.user-feedback-link.target.label",
        multiple: false,
        help: "pages.blocks.user-feedback-link.target.help",
        choices: [
          {
            value: "_blank",
            label: "pages.blocks.user-feedback-link.target.options._blank",
          },
          {
            value: "_self",
            label: "pages.blocks.user-feedback-link.target.options._self",
          }
        ]
      }
    }),
    type: propertyValue({
      type: 'select',
      value: "normal",
      options: {
        label: "pages.blocks.user-feedback-link.type.label",
        multiple: false,
        choices: [
          {
            value: "normal",
            label: "pages.blocks.user-feedback-link.type.options.normal",
          },
          {
            value: "light",
            label: "pages.blocks.user-feedback-link.type.options.light",
          },
          {
            value: "outlined",
            label: "pages.blocks.user-feedback-link.type.options.outlined",
          }
        ]
      }
    }),
    icon: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.user-feedback-link.icon.label",
        help: "pages.blocks.user-feedback-link.icon.help",
      }
    }),
    only_on_shop: propertyValue({
      type: 'shop_picker',
      value: '',
      options: {
        label: "pages.blocks.user-feedback-link.only-on-shop.label",
        help: "pages.blocks.user-feedback-link.only-on-shop.help",
        max: 1
      }
    })
  }),

  () => ({
    omitFields: ["type"] as const,
    tabs: [
      {
        label: "pages.blocks.user-feedback-link.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.user-feedback-link.fieldset.link.label",
            fields: ["text", "url", "target", "icon"],
          },
          {
            legend: "pages.blocks.user-feedback-link.fieldset.shop.label",
            fields: ["only_on_shop"],
          },
        ],
      },
    ],
  })
);

export function userFeedbackLinkBlockDescriptor(): IBlockDescriptor;
export function userFeedbackLinkBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function userFeedbackLinkBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedUserFeedbackLinkBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedUserFeedbackLinkBlockDescriptor, userFeedbackLinkBlockProperties, fieldOrder);
}

export {
  userFeedbackLinkBlockBlocDefinition,
  userFeedbackLinkBlockDashboardLayout,
  userFeedbackLinkBlockProperties,
  userFeedbackLinkBlockConfig,
  userFeedbackLinkBlockResolveConfig,
};

export type UserFeedbackLinkBlockConfig = typeof userFeedbackLinkBlockConfig;
